import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../i18n/hooks';
import { Button } from '../../ui';
import './AcademyPromoSection.css';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@ArbiWin-SportsAnalytics';
const ACADEMY_FEATURES = ['feature1', 'feature2', 'feature3'];

/**
 * AcademyPromoSection - Landing promo block for ArbiWin Academy YouTube channel
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} Academy promo section
 */
const AcademyPromoSection = ({ className = '' }) => {
  const { t } = useTranslation();

  const handleSubscribeClick = () => {
    window.open(YOUTUBE_CHANNEL_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <section
      className={`landing-academy-promo ${className}`.trim()}
      aria-labelledby="academy-promo-title"
    >
      <div className="landing-academy-promo__container">
        <div className="landing-academy-promo__card">
          <div className="landing-academy-promo__headline">
            <h2 id="academy-promo-title" className="landing-academy-promo__title">
              {t('landing.academyPromo.title')}
            </h2>
            <p className="landing-academy-promo__intro">
              {t('landing.academyPromo.intro1')}
            </p>
            <p className="landing-academy-promo__intro">
              {t('landing.academyPromo.intro2')}
            </p>
            <p className="landing-academy-promo__intro-lead">
              {t('landing.academyPromo.introLead')}
            </p>
          </div>

          <ul className="landing-academy-promo__features">
            {ACADEMY_FEATURES.map((featureKey) => (
              <li key={featureKey} className="landing-academy-promo__feature">
                {t(`landing.academyPromo.${featureKey}`)}
              </li>
            ))}
          </ul>

          <div className="landing-academy-promo__actions">
            <Button
              variant="primary"
              size="large"
              onClick={handleSubscribeClick}
              className="landing-academy-promo__cta"
            >
              {t('landing.academyPromo.cta')}
            </Button>
            <p className="landing-academy-promo__disclaimer">
              {t('landing.academyPromo.disclaimer')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

AcademyPromoSection.propTypes = {
  className: PropTypes.string,
};

export default AcademyPromoSection;
